import React, { useState } from 'react';
import IMediaItem from '../../../interfaces/umbracoNodes/mediaItem';
import SVG from '../../rawSVG';

type TDimension = {
	width?: number;
	height?: number;
};

type TProps = {
	icon: IMediaItem;
	preserveDimensions?: boolean;
};

export const SVGIcon = ({ icon, preserveDimensions }: TProps) => {
	const [iconDimensions, setIconDimensions] = useState<TDimension>({});

	const processSVG = (code: string) => {
		if (!preserveDimensions) {
			return code;
		}
		const exactPattern =
			/<svg[^>]*(?:width\s*=\s*"(\d+)"[^>]*height\s*=\s*"(\d+)"|height\s*=\s*"(\d+)"[^>]*width\s*=\s*"(\d+)")[^>]*>/i;
		const exactDimensions = code.match(exactPattern);
		if (exactDimensions) {
			setIconDimensions({
				width: +exactDimensions[exactDimensions[1] ? 1 : 4],
				height: +exactDimensions[exactDimensions[2] ? 2 : 3],
			});
			return code;
		}

		const viewBoxPattern = /viewBox="[^"]* ([^"]*) ([^"]*)"/;
		const viewBoxDimensions = code.match(viewBoxPattern);
		if (viewBoxDimensions) {
			setIconDimensions({
				width: +viewBoxDimensions[1],
				height: +viewBoxDimensions[2],
			});
		}
		return code;
	};

	return (
		<SVG
			src={icon.Src}
			width={iconDimensions.width || '100%'}
			height={iconDimensions.height || '100%'}
			preProcessor={processSVG}
			title={icon.Name}
		/>
	);
};

SVGIcon.defaultProps = {
	preserveDimensions: false,
};
